const sv_messages = require('./sv/messages.json')

const SWEDISH_STRINGS = {
  translation: sv_messages
}

export default SWEDISH_STRINGS
